import React, { useRef, useState, useEffect } from "react";
import { useParams, Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import './../styles/default.css';
import './../styles/servicios.css';
import * as globals from './../components/GlobalScripts.js';
import NavbarTop from './default/Navbartop';
import Testimonials from './default/Testimonials';
import Preguntas from './default/Preguntas';
import Footer from './default/Footer';

const Servicios = () => {
    let path_api = localStorage.getItem('path_api');
    const location = useLocation();
    const navigate = useNavigate();
    const { categoria } = useParams();

    const [user, setUser] = useState([]);
    const [categoriasOptions, setCategoriasOptions] = useState([]);
    const [estadosCiudades, setEstadosCiudades] = useState([]);
    function getTomorrow() {
        const t = new Date();
        t.setDate(t.getDate() + 1);
        return t.toISOString().split('T')[0];
    }
    const [formDataSearch, setFormDataSearch] = useState({
        categoria: categoria ?? "Pintura",
        subcategoria: "",
        cantidad: 1,
        ancho: "",
        largo: "",
        aparato: "",
        opcion: "",
        //Anterior
        titulo: "Servicio con pre-cotización",
        descripcion_servicio: "",
        fecha: getTomorrow(),
        hora: "10:00",
        estado: "Jalisco",
        ciudad: "Guadalajara",
        action: "sendMessage",
        opt: "",
        precotizacion: 0
    });
    const [formDataSearchAct, setFormDataSearchAct] = useState({});
    const [imagenesAdjuntas, setImagenesAdjuntas] = useState([]);

    useEffect(() => {
        const cachedData = localStorage.getItem('formDataSearch');
        const useCache = localStorage.getItem('useCache');
        if (cachedData && useCache) {
            setFormDataSearch(JSON.parse(cachedData));
            setFormDataSearchAct(JSON.parse(cachedData));
            localStorage.removeItem('useCache');
        }

        const user_cache = localStorage.getItem('user');
        if (user_cache) {
            setUser(JSON.parse(user_cache));
        }

        get_categorias();
        get_estados_ciudades();
    }, []);

    useEffect(() => {
        if (!categoria || categoriasOptions.length === 0) return;

        const existe = categoriasOptions.some(row =>
            row.categoria === categoria
        );
        const seleccion = existe ? categoria : "Otra";

        setFormDataSearch(prev => ({
            ...prev,
            categoria: seleccion
        }));
        setFormDataSearchAct(prev => ({
            ...prev,
            categoria: seleccion
        }));
    }, [categoria, categoriasOptions]);

    const get_categorias = () => {
        axios.post(`${path_api}/default/get_data_categorias.php`, {
            rute: globals.getRuteBackend()
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setCategoriasOptions(response.data.categorias);
            } else {
                globals.createAlert({ type: "error", msg_title: "Error", msg: response.data.mensaje || "No se cargaron las categorias", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            }
        }).catch(error => {
            globals.createAlert({ type: "error", msg_title: "Error", msg: "Error al conectar con el servidor", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
        });
    };

    const get_estados_ciudades = () => {
        axios.post(`${path_api}/default/get_estados_ciudades.php`, {
            rute: globals.getRuteBackend()
        }).then(response => {
            if (response.data.mensaje === 'success') {
                const estados = response.data.estados;
                setEstadosCiudades(estados);
                setFormDataSearch(prev => {
                    const newEstado = prev.estado || (estados.length > 0 ? estados[0].nombre : "");
                    const estadoObj = estados.find(e => e.nombre === newEstado);
                    const newCiudad = prev.ciudad || (estadoObj && estadoObj.ciudades && estadoObj.ciudades.length > 0
                        ? estadoObj.ciudades[0].nombre
                        : "");
                    return {
                        ...prev,
                        estado: newEstado,
                        ciudad: newCiudad
                    };
                });
            } else {
                globals.createAlert({
                    type: "error",
                    msg_title: "Error",
                    msg: response.data.mensaje || "No se cargaron los estados y ciudades",
                    effect: "opacidad 2s, desplazamiento 2s",
                    time_life: 4000
                });
            }
        }).catch(error => {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al cargar estados y ciudades",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
        });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "categoria") {
            setFormDataSearch(prev => ({
                ...prev,
                categoria: value,
                descripcion_servicio: ""
            }));
        } else if (name === "estado") {
            const selectedState = estadosCiudades.find(item => item.nombre === value);
            const newCiudad = selectedState && selectedState.ciudades && selectedState.ciudades.length > 0
                ? selectedState.ciudades[0].nombre
                : "";
            setFormDataSearch(prev => ({
                ...prev,
                estado: value,
                ciudad: newCiudad,
            }));
        } else {
            setFormDataSearch(prev => ({ ...prev, [name]: value }));
        }
    };

    const changeCategoria = (cat) => {
        setFormDataSearch(prev => ({
            ...prev,
            categoria: cat,
            subcategoria: "",
            cantidad: 1,
            ancho: "",
            largo: "",
            aparato: "",
            opcion: "",
            opt: "",
            precotizacion: 0
        }));
    };


    const changeJob = (row) => {
        setFormDataSearch(prev => ({
            ...prev,
            opt: row.opt,
            precotizacion: row.precio,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formDataSearch.opt) {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Selecciona un tipo de trabajo",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
            return;
        }
        setFormDataSearchAct(formDataSearch);

        localStorage.setItem('formDataSearch', JSON.stringify(formDataSearch));

        const session_id = globals.get_session_id();
        const user_keylogin = globals.get_keylogin();
        const admin_keylogin = "key-tbBgLYjd1QJjemCtVDd3mko59mhMX6AyySzmwI0gbCD8";
        const keys = `${user_keylogin},${admin_keylogin}`;
        const sender = user_keylogin;
        const rute = globals.getRuteBackend();

        const subirImagenComoMensaje = async (imgFileOrBase64) => {
            const formData = new FormData();
            formData.append('rute', rute);
            formData.append('session_id', session_id);
            formData.append('keylogin', user_keylogin);
            formData.append('keys', keys);
            formData.append('msg', "");
            formData.append('sender', sender);

            let file;
            if (typeof imgFileOrBase64 === "string" && imgFileOrBase64.startsWith("data:image")) {
                const arr = imgFileOrBase64.split(',');
                const mime = arr[0].match(/:(.*?);/)[1];
                const bstr = atob(arr[1]);
                let n = bstr.length;
                const u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                file = new Blob([u8arr], { type: mime });
                formData.append('adjunto', file, `imagen_${Date.now()}.png`);
            } else {
                formData.append('adjunto', imgFileOrBase64);
            }

            return axios.post(`${path_api}/chat/send_message.php`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
        };

        try {
            if (imagenesAdjuntas && imagenesAdjuntas.length > 0) {
                for (let i = 0; i < imagenesAdjuntas.length; i++) {
                    await subirImagenComoMensaje(imagenesAdjuntas[i]);
                }
            }
        } catch (error) {
            globals.createAlert({
                type: "error",
                msg_title: "Error",
                msg: "Error al subir imágenes",
                effect: "opacidad 2s, desplazamiento 2s",
                time_life: 4000
            });
            return;
        }
        
        navigate("/chat/key-tbBgLYjd1QJjemCtVDd3mko59mhMX6AyySzmwI0gbCD8?action=presupuesto");
    };

    const needAccount = () => {
        localStorage.setItem('url_redirect', location.pathname);
        localStorage.setItem('formDataSearch', JSON.stringify(formDataSearch));
        navigate("/quiero-contratar");
    };

    useEffect(() => {
        if (formDataSearch.categoria === "Pintura" && formDataSearch.ancho && formDataSearch.largo && formDataSearch.subcategoria) {
            const cat = categoriasOptions.find(item => item.categoria === "Pintura");
            let precio = 0;
            if (cat && cat.data_categoria && cat.data_categoria.form) {
                let optIdx = formDataSearch.subcategoria === "Con material" ? 0 : 1;
                precio = Number(cat.data_categoria.form[optIdx].precio) || 0;
            }
            setFormDataSearch(prev => ({
                ...prev,
                precotizacion: (Number(prev.ancho) * Number(prev.largo) * precio) || 0,
                opt: `${prev.subcategoria} ${prev.ancho}x${prev.largo}`
            }));
        }
    }, [formDataSearch.subcategoria, formDataSearch.ancho, formDataSearch.largo]);

    useEffect(() => {
        if (
            ["Fontanero", "Electricista", "Armado de Muebles"].includes(formDataSearch.categoria) &&
            formDataSearch.opcion && formDataSearch.cantidad
        ) {
            const cat = categoriasOptions.find(item => item.categoria === formDataSearch.categoria);
            let precio = 0;
            if (cat && cat.data_categoria && cat.data_categoria.form) {
                const selected = cat.data_categoria.form.find(o => o.opt === formDataSearch.opcion);
                precio = Number(selected?.precio) || 0;
            }
            setFormDataSearch(prev => ({
                ...prev,
                precotizacion: precio * Number(prev.cantidad),
                opt: `${prev.opcion} x ${prev.cantidad}`
            }));
        }
    }, [formDataSearch.categoria, formDataSearch.opcion, formDataSearch.cantidad]);

    useEffect(() => {
        if (
            formDataSearch.categoria === "Instalación de aparatos domésticos" &&
            formDataSearch.aparato && formDataSearch.opcion
        ) {
            const cat = categoriasOptions.find(item => item.categoria === formDataSearch.categoria);
            let precio = 0;
            if (cat && cat.data_categoria && cat.data_categoria.form) {
                const selected = cat.data_categoria.form.find(o => o.opt === formDataSearch.opcion);
                precio = Number(selected?.precio) || 0;
            }
            setFormDataSearch(prev => ({
                ...prev,
                precotizacion: precio,
                opt: formDataSearch.opcion
            }));
        }
    }, [formDataSearch.categoria, formDataSearch.aparato, formDataSearch.opcion]);


    return (
        <>
            <div className="app-default app-container">
                <NavbarTop />
                <div className="main-content page-servicios">
                    <div className="page-container">
                        <div className="container-section section flex-column gap-40">
                            <div className="overlay-container-full-width">
                                <div className="overlay-effect-primary left"></div>
                                <div className="overlay-effect-secundary right"></div>
                            </div>

                            <div className="flex-column gap-10">
                                <h1 className="center">Solicita tu <b style={{ color: "var(--color-primary)" }}>servicio</b></h1>
                                <h5 className="center">
                                    Trabajamos con profesionales verificados en tres rubros clave para el hogar. <br />
                                    Seleccioná el que mejor se ajuste a tu necesidad y empezá tu solicitud
                                </h5>
                            </div>

                            <form onSubmit={handleSubmit} className="container-services">
                                <div className="sidebar-services">
                                    <button
                                        type="button"
                                        className={"button-cat" + (formDataSearch?.categoria == 'Pintura' ? " active" : "")}
                                        onClick={() => changeCategoria('Pintura')}
                                    >
                                        <img src="/imagenes/servicios/pintura.png" />
                                        Pintura
                                    </button>
                                    <button
                                        type="button"
                                        className={"button-cat" + (formDataSearch?.categoria == 'Fontanero' ? " active" : "")}
                                        onClick={() => changeCategoria('Fontanero')}
                                    >
                                        <img src="/imagenes/servicios/fontanero.png" />
                                        Fontanero
                                    </button>
                                    <button
                                        type="button"
                                        className={"button-cat" + (formDataSearch?.categoria == 'Electricista' ? " active" : "")}
                                        onClick={() => changeCategoria('Electricista')}
                                    >
                                        <img src="/imagenes/servicios/electricidad.png" />
                                        Electricidad
                                    </button>
                                    <button
                                        type="button"
                                        className={"button-cat" + (formDataSearch?.categoria == 'Armado de Muebles' ? " active" : "")}
                                        onClick={() => changeCategoria('Armado de Muebles')}
                                    >
                                        <img src="/imagenes/servicios/armado.png" />
                                        Armado de Muebles
                                    </button>
                                    <button
                                        type="button"
                                        className={"button-cat" + (formDataSearch?.categoria == 'Instalación de aparatos domésticos' ? " active" : "")}
                                        onClick={() => changeCategoria('Instalación de aparatos domésticos')}
                                    >
                                        <img src="/imagenes/servicios/instalacion.png" />
                                        Instalación de aparatos domésticos
                                    </button>
                                    <button
                                        type="button"
                                        className="button-cat"
                                        onClick={() => navigate("/categorias")}
                                    >
                                        <img src="/imagenes/servicios/otros.png" />
                                        Otros
                                    </button>
                                </div>

                                <div className="content-form">
                                    <h4 style={{ color: "var(--color-primary-opacity7)" }}>Detalla tu solicitud</h4>
                                    <h5>Completa este formulario para poder saber sobre lo que necesitas y consigue una cotización inmediata</h5>

                                    <div className="flex-column gap-10 margin-top">
                                        <h4 className="required">¿Qué tipo de trabajo necesitas?</h4>
                                        {(() => {
                                            const cat = categoriasOptions.find(item => item.categoria === formDataSearch.categoria);

                                            if (formDataSearch.categoria === "Pintura") {
                                                return (
                                                    <>
                                                        <div className="opts-form">
                                                            {["Con material", "Sin material"].map(opt => (
                                                                <div
                                                                    key={opt}
                                                                    className={"opt-form" + (formDataSearch.subcategoria === opt ? " active" : "")}
                                                                    onClick={() => setFormDataSearch(prev => ({ ...prev, subcategoria: opt }))}
                                                                >
                                                                    {opt}
                                                                </div>
                                                            ))}
                                                        </div>
                                                        {
                                                            formDataSearch.subcategoria && (
                                                                <div className="form-grop-row margin-top">
                                                                    <div className="form-group">
                                                                        <label className="required">Ancho (m)</label>
                                                                        <input type="number" placeholder="Ancho (m)" value={formDataSearch.ancho}
                                                                            onChange={e => setFormDataSearch(prev => ({ ...prev, ancho: e.target.value }))}
                                                                            min={1}
                                                                            className="input-primary"
                                                                            required
                                                                        />
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label className="required">Largo (m)</label>
                                                                        <input type="number" placeholder="Largo (m)" value={formDataSearch.largo}
                                                                            onChange={e => setFormDataSearch(prev => ({ ...prev, largo: e.target.value }))}
                                                                            min={1}
                                                                            className="input-primary"
                                                                            required
                                                                        />
                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                    </>
                                                )
                                            } else if (
                                                ["Fontanero", "Electricista", "Armado de Muebles"].includes(formDataSearch.categoria)
                                            ) {
                                                return (
                                                    <>
                                                        <div className="opts-form">
                                                            {cat.data_categoria.form.map((row, i) => (
                                                                <div
                                                                    key={i}
                                                                    className={"opt-form" + (formDataSearch.opcion === row.opt ? " active" : "")}
                                                                    onClick={() => setFormDataSearch(prev => ({ ...prev, opcion: row.opt, cantidad: 1 }))}
                                                                >
                                                                    {row.opt}
                                                                </div>
                                                            ))}
                                                        </div>
                                                        {
                                                            formDataSearch.opcion && (
                                                                <div className="form-group margin-top">
                                                                    <label className="required">Cantidad</label>
                                                                    <input
                                                                        type="number"
                                                                        min={1}
                                                                        value={formDataSearch.cantidad}
                                                                        onChange={e => setFormDataSearch(prev => ({ ...prev, cantidad: e.target.value }))}
                                                                        className="input-primary"
                                                                        placeholder="Cantidad"
                                                                        required
                                                                    />
                                                                </div>
                                                            )
                                                        }
                                                    </>
                                                )
                                            } else if (formDataSearch.categoria === "Instalación de aparatos domésticos") {
                                                return (
                                                    <>
                                                        <div className="opts-form">
                                                            {["Lavadora", "Refrigerador", "Estufa", "TV"].map(ap => (
                                                                <div
                                                                    key={ap}
                                                                    className={"opt-form" + (formDataSearch.aparato === ap ? " active" : "")}
                                                                    onClick={() => setFormDataSearch(prev => ({ ...prev, aparato: ap, opcion: "" }))}
                                                                >
                                                                    {ap}
                                                                </div>
                                                            ))}
                                                        </div>
                                                        {
                                                            formDataSearch.aparato && (
                                                                <>
                                                                    <h4 className="required margin-top">Selecciona una opción</h4>
                                                                    <div className="opts-form">
                                                                        {cat.data_categoria.form
                                                                            .filter(o => o.opt.toLowerCase().includes(formDataSearch.aparato.toLowerCase()))
                                                                            .map((row, i) => {
                                                                                const optStr = row.opt.replace(`${formDataSearch.aparato} - `, "");
                                                                                return (
                                                                                    <div
                                                                                        key={i}
                                                                                        className={"opt-form" + (formDataSearch.opcion === row.opt ? " active" : "")}
                                                                                        onClick={() => setFormDataSearch(prev => ({ ...prev, opcion: row.opt }))}
                                                                                    >
                                                                                        {optStr}
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                    </div>
                                                                </>
                                                            )
                                                        }
                                                    </>
                                                )
                                            }
                                        })()}
                                    </div>

                                    <div className="form-upload-images">
                                        <h4>¿Quieres adjuntar una imagen?</h4>
                                        <div
                                            className="image-upload-box"
                                            onClick={() => {
                                                if (imagenesAdjuntas.length < 3) {
                                                    document.getElementById("input-img-adjunta").click();
                                                }
                                            }}
                                        >
                                            {imagenesAdjuntas.length === 0 && (
                                                <div className="image-upload-placeholder">
                                                    <span className="image-upload-plus">+</span>
                                                    <span className="image-upload-text">Adjuntar imagen</span>
                                                </div>
                                            )}
                                            {imagenesAdjuntas.map((img, idx) => (
                                                <div className="image-upload-preview" key={idx}>
                                                    <img src={img} alt={`img-${idx}`} />
                                                    <button
                                                        type="button"
                                                        className="image-upload-delete"
                                                        onClick={e => {
                                                            e.stopPropagation();
                                                            setImagenesAdjuntas(imagenesAdjuntas.filter((_, i) => i !== idx));
                                                        }}
                                                        title="Eliminar imagen"
                                                    >×</button>
                                                </div>
                                            ))}
                                            {imagenesAdjuntas.length < 3 && (
                                                <div
                                                    className="image-upload-plusbox"
                                                    onClick={e => {
                                                        e.stopPropagation();
                                                        document.getElementById("input-img-adjunta").click();
                                                    }}
                                                >+</div>
                                            )}
                                            <input
                                                type="file"
                                                id="input-img-adjunta"
                                                style={{ display: "none" }}
                                                accept="image/*"
                                                onChange={e => {
                                                    const file = e.target.files[0];
                                                    if (file && file.type.startsWith("image/")) {
                                                        const reader = new FileReader();
                                                        reader.onload = ev => {
                                                            setImagenesAdjuntas(prev =>
                                                                prev.length < 3 ? [...prev, ev.target.result] : prev
                                                            );
                                                        };
                                                        reader.readAsDataURL(file);
                                                        e.target.value = "";
                                                    }
                                                }}
                                            />
                                        </div>
                                        <span className="image-upload-hint">
                                            Puedes adjuntar hasta 3 imágenes.
                                        </span>
                                    </div>


                                    <div className="flex-column gap-10 margin-top-15">
                                        <h4 className="required">¿Cuándo puede pasar el profesional?</h4>
                                        <div className="form-grop-row">
                                            <input
                                                type="date"
                                                name="fecha"
                                                value={formDataSearch.fecha}
                                                onChange={handleChange}
                                                className="input-primary"
                                                required
                                            />

                                            <input
                                                type="time"
                                                name="hora"
                                                value={formDataSearch.hora}
                                                onChange={handleChange}
                                                className="input-primary"
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="flex-column gap-10 margin-top-15">
                                        <h4 className="required">Indique estado y ciudad donde se requiere el servicio</h4>
                                        <div className="form-grop-row">
                                            <select
                                                name="estado"
                                                value={formDataSearch.estado}
                                                onChange={handleChange}
                                                className="input-primary"
                                                required
                                            >
                                                {estadosCiudades.map((item, index) => (
                                                    <option key={index} value={item.nombre}>
                                                        {item.nombre}
                                                    </option>
                                                ))}
                                            </select>

                                            <select
                                                name="ciudad"
                                                value={formDataSearch.ciudad}
                                                onChange={handleChange}
                                                className="input-primary"
                                                required
                                            >
                                                {(() => {
                                                    const selectedState = estadosCiudades.find(
                                                        (item) => item.nombre === formDataSearch.estado
                                                    );
                                                    return selectedState && selectedState.ciudades
                                                        ? selectedState.ciudades.map((ciudad) => (
                                                            <option key={ciudad.id} value={ciudad.nombre}>
                                                                {ciudad.nombre}
                                                            </option>
                                                        ))
                                                        : null;
                                                })()}
                                            </select>
                                        </div>
                                    </div>

                                    <div className="flex-column gap-10 margin-top-15">
                                        <h4 className="required">Descripción de servicio</h4>
                                        <textarea
                                            type="text"
                                            name="descripcion_servicio"
                                            value={formDataSearch.descripcion_servicio}
                                            onChange={handleChange}
                                            className="input-primary"
                                            placeholder={categoriasOptions.filter(item => item.categoria === formDataSearch?.categoria)[0]?.descripcion}
                                            rows="6"
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="budget">
                                    <div className="budget-content">
                                        <h5>Presupuesto preliminar</h5>
                                        <h1>$ {formDataSearch?.precotizacion} <b style={{ fontSize: "var(--font-size-h4)" }}>MXN</b></h1>
                                        {globals.isAuthenticated() && (
                                            <button className="button-primary">
                                                Enviar solicitud
                                                <img src="/iconos/icono-send.png" />
                                            </button>
                                        )}
                                        {!globals.isAuthenticated() && (
                                            <button type="button" className="button-primary" onClick={needAccount}>
                                                Continuar
                                                <img src="/iconos/icono-send.png" />
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </form>

                        </div>

                        <Testimonials />

                        <Preguntas />
                    </div>
                </div>
                <Footer />
            </div>
        </>
    );
};

export default Servicios;